import { render, staticRenderFns } from "./EmailSelection.vue?vue&type=template&id=1d529834&scoped=true&"
import script from "./EmailSelection.vue?vue&type=script&lang=js&"
export * from "./EmailSelection.vue?vue&type=script&lang=js&"
import style0 from "./EmailSelection.vue?vue&type=style&index=0&id=1d529834&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d529834",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Proyects\\Happybox\\happyboxstore-repo\\email-shipping\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d529834')) {
      api.createRecord('1d529834', component.options)
    } else {
      api.reload('1d529834', component.options)
    }
    module.hot.accept("./EmailSelection.vue?vue&type=template&id=1d529834&scoped=true&", function () {
      api.rerender('1d529834', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "EmailShipping/components/EmailSelection.vue"
export default component.exports